<template>
	<div class="container">
		<template>
			<el-carousel trigger="click" :interval="4000" height="720px">
				<el-carousel-item v-for="(item, index) in imgs" :key="index">
					<img
						style="width: 100%; height: 100%"
						v-lazy="`${$queryUrl}${item.carouselUrl}`"
						alt=""
					/>
					<el-button
						v-if="item.moreFlag"
						class="carousel-button"
						type="primary"
						@click="showMore"
						>{{ $t("more") }}</el-button
					>
				</el-carousel-item>
			</el-carousel>
		</template>
		<div class="container-content">
			<!-- <div class="home-product">
				<div class="contact-title">
					<div class="contact-title-t1">{{ $t("avdio") }}</div>
					<span></span>
				</div>
				<div class="vedio-img">
					<video-player
						class="video-player vjs-custom-skin"
						ref="videoPlayer"
						:playsinline="true"
						:options="playerOptions"
					></video-player>
				</div>
			</div> -->
			<div class="home-product">
				<div class="contact-title">
					<div class="contact-title-t1">{{ $t("information") }}</div>
					<span></span>
				</div>
				<el-carousel :autoplay="false" arrow="always">
					<el-carousel-item v-for="(item, i) in productInfo" :key="i">
						<div
							class="img-box"
							v-for="(d, index) in item"
							@click="gotoDetails(d)"
							:key="index"
						>
							<img v-lazy="`${$queryUrl}${d.productImage}`" />
							<div>{{ d.categoriesName1 }}</div>
							<div>{{ d.productName }}</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="home-product">
				<div class="contact-title">
					<div class="contact-title-t1">{{ $t("customers") }}</div>
					<span></span>
				</div>
				<div class="my-partner">
					<div v-for="(item, index) in clientInfo" :key="index">
						<img
							v-lazy="`${$queryUrl}${item.clientImage}`"
							alt=""
						/>
					</div>
				</div>
			</div>
			<div class="home-product">
				<div class="contact-title">
					<div class="contact-title-t1">{{ $t("partners") }}</div>
					<span></span>
				</div>
				<div class="my-partner">
					<div v-for="(item, index) in partnerInfo" :key="index">
						<img
							v-lazy="`${$queryUrl}${item.partnerImage}`"
							alt=""
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			product: this.$t("heardProduct"),
			imgs: [],
			companyMsg: {},
			companyImg: [],
			productInfo: [],
			filterProduct: 1,
			clientInfo: [],
			vedioUrl: "",
			autoplay: false,
			partnerInfo: [],
			playerOptions: {
				playbackRates: [0.5, 1.0, 1.5, 2.0], //播放速度
				autoplay: false, //如果true,浏览器准备好时开始回放。
				controls: true,
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 导致视频一结束就重新开始。
				preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: "zh-CN",
				aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [],
				poster: "", //你的封面地址
				// width: document.documentElement.clientWidth,
				notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
					fullscreenToggle: true, //全屏按钮
				},
			},
		};
	},
	computed: {
		companyImgFilter: function() {
			return this.companyImg.filter((item) => {
				return item;
			});
		},
	},
	created() {
		this.getCarouselList();
		this.getcompanyMsg();
		this.getProductInfo();
		this.getClientInfo();
		this.getPartnerInfo();
	},
	methods: {
		// 轮播图
		getCarouselList() {
			this.$axios.post(`selectHomePageCarouselInfo`).then((res) => {
				this.imgs = res.data.data;
			});
		},
		// 公司信息
		getcompanyMsg() {
			this.$axios.post(`selectCompanyInfo`).then((res) => {
				this.companyMsg = res.data.data[0];
				this.companyImg.push(
					this.companyMsg.image1,
					this.companyMsg.image2,
					this.companyMsg.image3,
					this.companyMsg.image4
				);
				// this.playerOptions.sources = [
				// 	{
				// 		type: "",
				// 		src: `${this.$queryUrl}${this.companyMsg.video};`, //视频url地址
				// 	},
				// ];
				// console.log(this.playerOptions.sources, 456498798);
				// this.vedioUrl = this.companyMsg.video;
			});
		},
		// 主要产品信息
		getProductInfo() {
			this.$axios.post(`selectHomePageProductInfo`).then((res) => {
				let { data } = res.data;
				let arr = [];
				this.filterProduct = Math.ceil(data.length / 4);
				for (let i = 0; i < this.filterProduct; i++) {
					arr.push([]);
					arr[i].push(data[i * 4 + 0]);

					data[i * 4 + 1] && arr[i].push(data[i * 4 + 1]);
					data[i * 4 + 2] && arr[i].push(data[i * 4 + 2]);
					data[i * 4 + 3] && arr[i].push(data[i * 4 + 3]);
				}
				this.productInfo = arr;
				console.log(this.productInfo);
			});
		},
		// 客户信息
		getClientInfo() {
			this.$axios.post(`selectClientInfo`).then((res) => {
				this.clientInfo = res.data.data;
			});
		},
		getPartnerInfo() {
			this.$axios.post(`selectPartnerInfo`).then((res) => {
				this.partnerInfo = res.data.data;
			});
		},
		// 播放视频
		openVideo() {
			this.autoplay = true;
		},
		showMore() {
			this.$router.push({ path: "/product" });
		},
		gotoDetails(d) {
			this.$router.push({
				name: "productDetails",
				params: { id: d.productName },
				query: d,
			});
		},
	},
};
</script>

<style lang="scss">
.container {
	.el-carousel__container {
		position: relative;
	}
	.carousel-button {
		position: absolute;
		bottom: 24px;
		left: 150px;
	}
	.el-carousel__indicator .el-carousel__button {
		background-color: #333;
	}
	.el-carousel__indicator.is-active .el-carousel__button {
		background-color: #ff9801;
	}
	.container-content {
		margin: 0 auto;
		width: 1200px;
		height: auto;
		margin-bottom: 60px;
	}
	/* min-height: 100vh; */
	.home-product {
		.vedio-img {
			.video-player {
				width: 649px;
				height: 360px;
				margin: 0 auto 20px;
				.video-js {
					cursor: pointer;
				}
				.video-js:hover {
					.vjs-big-play-button {
						background-color: rgba(255, 255, 255, 0.2);
					}
				}
				.vjs-slider-bar,
				.vjs-volume-level {
					background-color: #f44336;
				}
				.vjs-big-play-button {
					border-radius: 100%;
					width: 2em;
				}
			}
		}
		.el-carousel {
			.el-carousel__indicators {
				display: none !important;

				.el-carousel__item {
					img {
						height: 100%;
						width: 100%;
					}
				}
			}
			.el-carousel__item {
				display: flex;

				.img-box {
					width: calc(25% - 6px);
					margin: 0 6px;
					border: 1px solid #dcdfe6;
					text-align: center;
					overflow: hidden;
					img {
						height: 248px;
						max-width: 100%;
						&:hover {
							transform: scale(1.1);
						}
					}
					cursor: pointer;
					div {
						line-height: 24px;
					}
				}
			}
		}

		> img {
			height: 324px;
			width: 100%;
		}
		.product-img-box {
			.img-box-item {
				> div {
					width: 33%;
					float: left;
					text-align: center;
					border: 1px solid #dcdfe6;
				}
				> div + div {
					margin-left: 10px;
				}
				.product-name {
					padding-bottom: 10px;
				}
				img {
					height: 284px;
				}
			}
		}
		.my-partner {
			display: flex;
			flex-wrap: wrap;
			div {
				width: 300px;
				height: 100px;
				line-height: 100px;
				text-align: center;
			}
			img {
				width: 132px;
			}
		}
	}
	.company-profile {
		padding: 16px 0;
		h3 {
			font-size: 26px;
			color: #666;
			padding-bottom: 20px;
		}
		p {
			padding: 0 14px 14px 0;
			text-indent: 2em;
			font-size: 14px;
			line-height: 24px;
			color: #666;
		}

		.company-content {
			display: flex;
			div {
				flex: 1;
				img {
					width: 100%;
				}
			}
		}
		.company-profile-img {
			display: flex;
			> div {
				flex: 1;
				img {
					width: 100%;
				}
			}
		}
	}
	video {
		width: 780px;
	}
	.contact-title {
		visibility: visible;
		animation-name: fadeInUp;
		text-align: center;
		width: 1200px;
		margin: 0 auto;
		padding: 4% 0 3%;
		.contact-title-t1 {
			font-size: 30px;
			color: #666;
		}
		.contact-title-t2 {
			font-size: 20px;
			color: #333;
		}
		span {
			display: inline-block;
			width: 33px;
			height: 3px;
			background: #ff9801;
			margin: 10px 0;
		}
	}
}
</style>
